import { HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, catchError, throwError, tap } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { LoadingService } from 'src/app/shared/components/loading/loading.service';
import { LoadingKeys } from 'src/app/shared/components/loading/loading-constants';
import { environment } from 'src/environments/environment';

export const CALL_LOADING = new HttpContextToken<LoadingKeys>(() => 'none');



@Injectable({
  providedIn: 'root'
})
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(
    private loadingService: LoadingService,
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.context.has(CALL_LOADING)) {
      // return next.handle(req);
      this.loadingService.startLoading( req.context.get(CALL_LOADING))
    }

    this.loadingService.startLoadingAutoKey({req})
    return next.handle(req).pipe(
      catchError((error) => {
        // console.log({error, req})
        if ( req.context.has(CALL_LOADING)) {
          this.loadingService.finishLoading( req.context.get(CALL_LOADING))
        }
        this.loadingService.finisgLoadingAutoKey({req})

        return next.handle(req)
      }),
      tap( (event) => {
        if ( ( !(event instanceof HttpResponse)  ) ) {
          return
        }
        this.loadingService.finisgLoadingAutoKey({req})

        // event instance of HttpResponse determina se a func esta interceptando um response ( e nao apenas um request)
        if (req.context.has(CALL_LOADING)) {
          this.loadingService.finishLoading( req.context.get(CALL_LOADING))

        }
        // if (req.url.split(environment.datastore).pop() == 'getDiagnosis1') {
        //   console.log(req)
        // }
        // if ( event instanceof HttpResponse) {
          // return next.handle(req);

      } )
    )
    ;
  }
}
